import ManageCarWashes from "./ManageCarWashes";

export default ManageCarWashes;
